import ToggleSort from './toggle-sort';

export default ToggleSort;